export { InstoreEnrollmentPage } from './instore-enrollment-page';
